import React, { useEffect, useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import $ from 'jquery';
import 'datatables.net'; // Import DataTables
import { ref, storage, query, where, db, collection, doc, setDoc, getDocs, deleteDoc, orderBy, serverTimestamp, uploadBytesResumable, getDownloadURL } from '../../../config/firebaseConfig.js'; // Pastikan jalur benar
import { jwtDecode } from 'jwt-decode';
import Select from "react-select";
import Swal from "sweetalert2";
import "react-loading-skeleton/dist/skeleton.css";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // CSS bawaan te

const ViewRombelJurnal = () => {

    const [rombel, setrombel] = useState([]);
    const [jadwal, setjadwal] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/refjadwal/getjadwalpembelajaran`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${localStorage.getItem('authToken')}`,
                    },
                });

                if (!response.ok) {
                    throw new Error("Failed to fetch kelas");
                }

                const data = await response.json();


                setrombel(data.rombel);
                setjadwal(data.jadwaldata)

            } catch (error) {
                Swal.fire("Error!", error.message || 'Something went wrong', "error");
            }
        };

        fetchData();
    }, []);
    return (
        <div>
            <div className="pc-container">
                <div className="pc-content">
                    <div className="row">
                        <div class="col-xxl-3 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <p class="mb-1 fw-medium text-muted">Sikap</p>
                                            <h4 class="mb-1">980+</h4>
                                            <p class="mb-0 text-sm">May 23 - June 01 (2018)</p>
                                        </div>
                                        <div class="flex-shrink-0">
                                            <div class="avtar avtar-l bg-light-primary rounded-circle">
                                                <i class="ph-duotone ph-book-bookmark f-28"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-3 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <p class="mb-1 fw-medium text-muted">Kehadiran</p>
                                            <h4 class="mb-1">980+</h4>
                                            <p class="mb-0 text-sm">May 23 - June 01 (2018)</p>
                                        </div>
                                        <div class="flex-shrink-0">
                                            <div class="avtar avtar-l bg-light-primary rounded-circle">
                                                <i class="ph-duotone ph-book-bookmark f-28"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-3 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <p class="mb-1 fw-medium text-muted">Penilaian</p>
                                            <h4 class="mb-1">980+</h4>
                                            <p class="mb-0 text-sm">May 23 - June 01 (2018)</p>
                                        </div>
                                        <div class="flex-shrink-0">
                                            <div class="avtar avtar-l bg-light-primary rounded-circle">
                                                <i class="ph-duotone ph-book-bookmark f-28"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="col-xxl-3 col-md-6">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <p class="mb-1 fw-medium text-muted">Batas Pembelajaran</p>
                                            <h4 class="mb-1">980+</h4>
                                            <p class="mb-0 text-sm">May 23 - June 01 (2018)</p>
                                        </div>
                                        <div class="flex-shrink-0">
                                            <div class="avtar avtar-l bg-light-primary rounded-circle">
                                                <i class="ph-duotone ph-book-bookmark f-28"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xxl-6 col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <h5 className='mb-0'>Grafik Kehadiran Peserta Didik</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-xxl-6 col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <h5 className='mb-0'>Grafik Kehadiran Pendidik</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-xxl-6 col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <h5 className='mb-0'>Grafik Prilaku</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="col-xxl-6 col-md-12">
                            <div class="card">
                                <div class="card-body">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1 me-3">
                                            <h5 className='mb-0'>Grafik Capaian Kompetensi</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}


export default ViewRombelJurnal;